import { render, staticRenderFns } from "./ProfileStartup.vue?vue&type=template&id=18a56606&scoped=true&"
import script from "./ProfileStartup.vue?vue&type=script&lang=js&"
export * from "./ProfileStartup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStartup.vue?vue&type=style&index=0&id=18a56606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a56606",
  null
  
)

export default component.exports